import { useState } from 'react';

import { Box } from '@simplywallst/ui-core';

import { OthersBreakdown } from './components/OthersBreakdown';
import { HoldingBreakdown } from './components/HoldingBreakdown';

import type { Portfolio } from '@/hooks/usePortfolio';

import { usePortfolioDiversificationAcrossHoldings } from './hooks';

import { OTHERS_LABEL } from './constants';

import { ResponsiveWidth } from '../ResponsiveWidth';

import { DiversificationDonutChart } from '../DiversificationDonutChart';

interface Props {
  portfolio: Portfolio;
}

export const DiversificationAcrossHoldings = ({ portfolio }: Props) => {
  const { data, others } = usePortfolioDiversificationAcrossHoldings(
    portfolio.holdings
  );

  const [selected, setSelected] = useState<number>(0);
  const holding = data[selected];
  return (
    <ResponsiveWidth>
      {({ width }) => (
        <Box
          position="relative"
          data-cy-id="diversification-across-holdings-chart"
        >
          {holding?.label === OTHERS_LABEL ? (
            <OthersBreakdown data={others} />
          ) : (
            <HoldingBreakdown holding={data[selected]} />
          )}
          <DiversificationDonutChart
            data={data.length > 0 ? data : undefined}
            width={width}
            selected={selected}
            onSelect={setSelected}
          />
        </Box>
      )}
    </ResponsiveWidth>
  );
};
